// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Initial State
const initialState = {
  actionsData: null,
  audioStatus: false,
  audioStatusInit: false,
  svgLoad: false,
  initAudio: null
};

// Redux Slice for Current Asset
const currentILTActionsSlice = createSlice({
  name: "currentILTActions",
  initialState,
  reducers: {
    resetState(state, { payload }) {
      return initialState;
    },
    setActionsData(state, { payload }) {
      return {
        ...state,
        actionsData: payload,
      };
    },
    setAudioStatus(state, { payload }) {
      return {
        ...state,
        audioStatus: payload,
      };
    },
    setAudioStatusInit(state, { payload }) {
      return {
        ...state,
        audioStatusInit: payload,
      };
    },
    setSvgLoad(state, { payload }) {
      return {
        ...state,
        svgLoad: payload,
      };
    },
    setInitAudio(state, { payload }) {
      return {
        ...state,
        initAudio: payload,
      };
    }
  },
});

export const currentILTActionsSliceActions = currentILTActionsSlice.actions;

export default currentILTActionsSlice;
